// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hx-0";